import { Button } from 'components/common';
import useBottomSheet from 'hooks/common/useBottomSheet';

const PrimeGemCostConfirm = () => {
  const { close, sheets } = useBottomSheet();
  const sheet = sheets.PrimeGemCostConfirm;
  const data = (sheet?.data ?? {}) as { cost?: number };
  const cost = data.cost ?? 0;

  const handleConfirm = () => {
    close('PrimeGemCostConfirm', { data: { confirmed: true } });
  };

  const handleCancel = () => {
    close('PrimeGemCostConfirm', { data: { confirmed: false } });
  };

  return (
    <div className="flex h-full w-full flex-col items-center gap-[var(--spacing-lg)]">
      <div className="flex w-full flex-col items-center gap-[var(--spacing-xs)]">
        <div className="typography-title-md text-center text-base-txt-primary">{brsc.gem_seeting_1}</div>
        <div className="typography-body-sm break-keep text-center text-base-txt-secondary">{brsc.gem_setting_2.replace('$param', cost)}</div>
      </div>
      <div className="flex w-full items-center justify-center gap-[var(--spacing-sm)] rounded-lg bg-base-bg-strong px-[var(--spacing-lg)] py-[var(--spacing-2xl)]">
        <img src="/imgweb/prime/gem.png" alt="gem" className="h-10 w-10" />
        <div className="text-4xl font-bold text-base-txt-primary">{cost}</div>
      </div>
      <div className="flex w-full items-center justify-center gap-[var(--spacing-sm)]">
        <Button onClick={handleCancel} style={{ color: 'btn-bg-normal', icon: { name: bassets.linkle.icon_set.closed.svg, size: 24 } }} className="h-14 min-w-14 flex-grow-0" />
        <Button
          onClick={handleConfirm}
          style={{ text: brsc.confirm, color: 'btn-bg-lovematch-primary', fontColor: 'btn-txt-lovematch-primary', borderRadius: 'full', fontTheme: 'typography-headline-lg' }}
          className="h-14"
        />
      </div>
    </div>
  );
};

export default PrimeGemCostConfirm;
